import axios from './../../function/axiosInstance';
import extract from './../../function/extract';
export const getDocsContent = async ({ id, isTemplate }) => {
    try {
        const response = await axios.get(`/${isTemplate ? 'templates' : 'assignments'}/${id}/editor`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getPublicDocsContent = async ({ id }) => {
    try {
        const response = await axios.get(`/assignments/${id}/editor`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getDocsVersions = async ({ id, page, limit, isTemplate }) => {
    try {
        const response = await axios.get(`/${isTemplate ? 'templates' : 'assignments'}/${id}/editor/versions?limit=${limit !== null && limit !== void 0 ? limit : 100}&page=${page !== null && page !== void 0 ? page : 1}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const postDocsContent = async ({ id, body, isTemplate }) => {
    try {
        const response = await axios.put(`/${isTemplate ? 'templates' : 'assignments'}/${id}/editor`, body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const updateDocsExtras = async ({ id, body }) => {
    try {
        const response = await axios.put(`/assignments/${id}/editor`, body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const updateDocsVersions = async ({ id, versionId, isTemplate }) => {
    try {
        const response = await axios.put(`/${isTemplate ? 'templates' : 'assignments'}/${id}/editor/versions/${versionId}/restore`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getDocAsPerVersion = async ({ id, versionId, isTemplate }) => {
    try {
        const response = await axios.get(`/${isTemplate ? 'templates' : 'assignments'}/${id}/editor/versions/${versionId}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getTokenForComment = async () => {
    try {
        const response = await axios.post(`/users/messages/token`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getTokenForGuestUserToComment = async ({ assignmentId, isTemplate }) => {
    try {
        const response = await axios.get(`/${isTemplate ? 'templates' : 'assignments'}/${assignmentId}/messages/guest-token`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const resolveComment = async ({ messageId }) => {
    try {
        const response = await axios.put(`/users/messages/${messageId}`, {
            resolve: true
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const publicAccessAssignment = async ({ id, publicRead, publicWrite, publicComment }) => {
    try {
        const payload = {
            public_read: publicRead,
            public_write: publicWrite,
            public_comment: publicComment
        };
        const response = await axios.put(`/assignments/${id}/editor/permission`, payload);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const uploadFile = async ({ id, isTemplate }) => {
    try {
        const response = await axios.get(`/${isTemplate ? 'templates' : 'assignments'}/${id}/editor/convert?output=docx`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getFile = async ({ id, assignmentId, status, isTemplate }) => {
    try {
        const response = await axios.get(`/${isTemplate ? 'templates' : 'assignments'}/${assignmentId}/editor/convert?conversion_id=${id}&&action=${status}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getTemplateInformation = async ({ id }) => {
    try {
        const response = await axios.get(`/templates/${id}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const deleteTemplate = async ({ id }) => {
    try {
        const response = await axios.delete(`/templates/${id}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getReferences = async ({ id, claim }) => {
    try {
        const response = await axios.post(`/assignments/${id}/reference_text`, {
            claim: claim
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const syncGetStreamMembers = async ({ id }) => {
    try {
        const response = await axios.post(`/assignments/${id}/messages/sync-members`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
//# sourceMappingURL=editor.js.map